/**
 * InfoTooltip.jsx
 *
 * Phase 2g, Task F: the smallest possible generic tooltip - a hover and
 * focus target with an accessible label, for arbitrary explanatory text.
 * StatusTooltip.jsx already exists but is keyed to a fixed vocabulary of
 * device statuses, not a fit for one-off label explanations across the
 * OnWatch pages. No tooltip library added, per project rules.
 *
 * Usage:
 *   <span className="ow-metric-label">Restarts 1h</span>
 *   <InfoTooltip text="Restarts in the last hour. ..." />
 */

import { useState, useRef, useId } from 'react';
import { Info } from 'lucide-react';

export default function InfoTooltip({ text, position = 'top' }) {
  const [visible, setVisible] = useState(false);
  const hideTimeout = useRef(null);
  const tooltipId = useId();

  const show = () => {
    clearTimeout(hideTimeout.current);
    setVisible(true);
  };
  const hide = () => {
    hideTimeout.current = setTimeout(() => setVisible(false), 80);
  };

  return (
    <span className="ow-info-tooltip-wrapper">
      <button
        type="button"
        className="ow-info-tooltip-trigger"
        aria-label={text}
        aria-describedby={visible ? tooltipId : undefined}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <Info size={12} />
      </button>
      {visible && (
        <span role="tooltip" id={tooltipId} className={`ow-info-tooltip ow-info-tooltip-${position}`}>
          {text}
        </span>
      )}
    </span>
  );
}
